// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"d8e2a990","455":"6faa78ab","977":"4c434bdf"}[chunkId] + ".chunk.js";
};